import { Brand, Brands } from "@utils/constants.util"
import { BrandNamesType } from "../pages/see-our-ships/EntityNavigationPage/EntityNavigationPage"

const URL_BRAND_CODE_TO_BRAND_NAME: Record<string, BrandNamesType> = {
	R: "ROYAL",
	C: "CELEBRITY",
	S: "SILVERSEA"
} as const

const BRAND_NAME_TO_URL_BRAND_CODE: Record<BrandNamesType, string> = {
	ROYAL: "R",
	CELEBRITY: "C",
	SILVERSEA: "S"
} as const

const BRAND_NAME_TO_BRAND: Record<BrandNamesType, Brand> = {
	ROYAL: Brands.ROYAL,
	CELEBRITY: Brands.CELEBRITY,
	SILVERSEA: Brands.SILVERSEA
}

const BRAND_TO_URL_BRAND_CODE: Record<NonNullable<Brand>, string> = {
	[Brands.ROYAL]: "R",
	[Brands.CELEBRITY]: "C",
	[Brands.SILVERSEA]: "S"
}

export const useBrandConversions = () => {
	const urlBrandCodeToBrandName = (
		brandCode: string | null
	): BrandNamesType => {
		if (!brandCode) return "ROYAL"
		return URL_BRAND_CODE_TO_BRAND_NAME[brandCode.toUpperCase()] ?? "ROYAL"
	}

	const brandNameToUrlBrandCode = (brandName: BrandNamesType): string => {
		return BRAND_NAME_TO_URL_BRAND_CODE[brandName] ?? "R"
	}

	const brandNameToBrand = (brandName: BrandNamesType): Brand => {
		return BRAND_NAME_TO_BRAND[brandName] ?? Brands.ROYAL
	}

	const brandToUrlBrandCode = (brand: Brand): string => {
		if (!brand) return "R"
		return BRAND_TO_URL_BRAND_CODE[brand] ?? "R"
	}

	return {
		urlBrandCodeToBrandName,
		brandNameToUrlBrandCode,
		brandNameToBrand,
		brandToUrlBrandCode
	}
}
